module.exports = __webpack_public_path__ + "static/media/caseiqdashboard.2b297590.png";